import { format } from "date-fns";

export const dateConvert = (date, time) => {
  if (date) {
    const datetime = new Date(date);

    if(time){
      return format(datetime, "dd-MM-yyyy HH:mm:ss");
    }
    else{
      return format(datetime, "dd-MM-yyyy");
    }
  }
};
